import { render, staticRenderFns } from "./EnquiryViaEmailStatItem.vue?vue&type=template&id=b7b256c0&"
import script from "./EnquiryViaEmailStatItem.vue?vue&type=script&lang=js&"
export * from "./EnquiryViaEmailStatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports